import styled from "styled-components";

export const StyledPopupConfirm = styled.div`
  max-width: 600px;
  white-space: pre-line;
`;

export const StyledLoadingMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 0;
`;
